
import { mapGetters } from "vuex"

const linkBase = "https://storage.yandexcloud.net/eventico-rif23/program"

export default {
  data: () => ({
    archLink: `${linkBase}/program_ru.pdf`,
    programLink: `${linkBase}/sessions_ru.pdf`,
  }),

  head () {
    return {
      title: this.getTitle(this.$t("pages.program.title")),
    }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },
}
